import { MuiOtpInput } from 'mui-one-time-password-input';
import { useEffect, useRef, useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, convertToNumber } from '../CommonComponents/CustomHooks';

const DealerForgotPassword = () => {
    const [user, setUser] = useState({
        userCode: '',
        LoginType: 'Dealer',
        NewPassword: '', ConfirmPassword: '',
        ForgetUserCode: ''
    });
    const [isLoading, setIsLoading] = useState(false)
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const [Response, setResponse] = useState({});
    const [timer, setTimer] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [showNewPasswordState, setShowNewPasswordState] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [loginData, setLoginData] = useState({
        userCode: '',
        password: '',
        type: 'DealerForgetPass',
        userType: 'Dealer',
        otp: '',
        captcha: '',
        validate: '',
        mobileNo: ''
    });
    useEffect(() => {
        document.title = 'Dealer Forget Password'
    }, [])

    const handleChangeLogin = (e, file) => {
        setLoginData({ ...loginData, [file]: (e.target.value) })
    };

    useEffect(() => {
        let interval;

        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0 && isDisabled) {
            setIsDisabled(false);
        }

        return () => clearInterval(interval);
    }, [timer, isDisabled]);

    const handleSendOtp = async () => {
        try {
            let data = await ApiCall(`/api/Login/SendOTPToMobileNo`, { ...loginData, "Type": "DealerForgetPass" });
            setResponse(data)
            setLoginData(prevData => ({ ...prevData, otp: '', validate: '' }));
            if (data.status === 'SUCCESS') {
                await setTimer(30);
                await setIsDisabled(true);
                setShowOtpInput(true);
            } else if (data.status === 'ERROR') {
                setShowOtpInput(false);
                await NotificationSound(data.status, data.message, data.focus, inputrefs);
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
        } finally {
        }
    };

    const handleVerify = async () => {
        let data = await ApiCall(`/api/Login/OTPVerification`, { ...loginData, "Type": "DealerForgetPass" });
        if (data.status === 'SUCCESS') {
            await setShowNewPasswordState(true)
        } else if (data.status === 'ERROR') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    };

    const HandleSubmit = async () => {
        setIsLoading(true);
        const data = {
            ...user,
            ForgetToken: '',
            LoginType: 'Dealer',
            ForgetUserCode: loginData.userCode,
            NewPassword: loginData.newPassword||'',
            ConfirmPassword: loginData.confirmPassword||'',
        }
        let res = await ApiCall(`/api/Login/UpdateForgotPassword`, data)
        if (res.status === 'SUCCESS') {
            await NotificationSound(res.status, res.message, res.focus, inputrefs, () => {
                navigate('/')
            })
            setUser(user => ({ ...user, NewPassword: '', ConfirmPassword: '' }))
        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };

    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };
    return (
        <>
            <section className='login-page'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 px-0">
                            <div className="login-image">
                                <img src="https://portal.cppwebservices.in/Content/Login/img/logo.png?v=2" alt="Logo" />
                                <h3>Welcome to <br />CPP Login Panel</h3>
                                <p className="top">Your one stop platform for</p>
                                <p>CPP Membership</p>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0 col-md-12 d-flex justify-content-between flex-column align-items-center">
                            <div className="aboutSec otpSec">
                                <div className="otpSecLft loginLft">
                                    <div className='ram'>
                                        <h2 className="logTitle">Dealer Forgot Password</h2>
                                        <div className="loginpSec mb-10 position-relative">
                                            <label htmlFor="txtDealerCode" className="form-label lbl"> Dealer Code</label>
                                            <input
                                                className="form-control txtField username"
                                                id="txtDealerCode"
                                                disabled={showOtpInput}
                                                style={{
                                                    cursor: showOtpInput? 'not-allowed' : '',
                                                    backgroundColor: showOtpInput? 'lightgray' : 'transparent',
                                                }}
                                                ref={ref => (inputrefs.current['txtDealerCode'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        const SendOtp = async () => {
                                                            await handleSendOtp();
                                                        };
                                                        SendOtp();
                                                    };
                                                }}
                                                placeholder='Dealer Code'
                                                maxLength="15"
                                                autoComplete="off"
                                                value={loginData.userCode}
                                                onChange={(e) => handleChangeLogin(e, 'userCode')}
                                            />

                                        </div>
                                        {isDisabled &&
                                            < span className={'text-success'}>{Response.message}</span>
                                        }
                                        {showOtpInput && (
                                            <div className='mt-2 mb-1'>
                                                <label htmlFor="txtotp" className="form-label">Enter 6 Digit OTP</label>
                                                <MuiOtpInput
                                                    id="txtotp"
                                                    value={loginData.otp}
                                                    ref={(ref) => (inputrefs.current['txtotp'] = ref)}
                                                    length={6}
                                                    onChange={(otp) => setLoginData({ ...loginData, otp: convertToNumber(otp) })}
                                                    containerStyle={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        cursor: showNewPasswordState ? 'not-allowed' : 'pointer',
                                                    }}
                                                    inputStyle={{
                                                        height: '48px',
                                                        textAlign: 'center',
                                                        fontSize: '1rem',
                                                        borderRadius: '4px',
                                                        cursor: showNewPasswordState ? 'not-allowed' : 'pointer',
                                                        backgroundColor: showNewPasswordState ? 'gray' : 'transparent',
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            inputrefs.current['txtValidate'].focus();
                                                        }
                                                    }}
                                                    disabled={showNewPasswordState}
                                                    style={{ cursor: showNewPasswordState ? 'not-allowed' : 'pointer', }}
                                                />

                                                <p className='mt-3 mb-2 d-flex justify-content-center align-items-center'>
                                                    Didn't receive an OTP?
                                                    <button
                                                        type="button"
                                                        onClick={handleSendOtp}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            color: '#007bff',
                                                            fontWeight: 'bold',
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            marginLeft: '7px',
                                                            opacity: isDisabled ? 0.5 : 1,
                                                        }}
                                                        disabled={isDisabled}
                                                    >
                                                        {isDisabled ? `Resend (${timer}s)` : 'Resend'}
                                                    </button>
                                                </p>
                                            </div>
                                        )}
                                        {!showOtpInput ? (
                                            <button
                                                type="button"
                                                ref={ref => (inputrefs.current['btnSub'] = ref)}
                                                id="btnLogin"
                                                className="pageBtn otpBtn btn-login"
                                                onClick={handleSendOtp}
                                            >
                                                Next
                                            </button>
                                        ) : (
                                            <>
                                                {!showNewPasswordState ? (
                                                    <button
                                                        type="button"
                                                        ref={ref => (inputrefs.current['btnSub'] = ref)}
                                                        id="btnLogin"
                                                        className="pageBtn otpBtn btn-login"
                                                        onClick={handleVerify}
                                                    >
                                                        Verify
                                                    </button>
                                                ) : (null
                                                )}
                                            </>
                                        )}
                                        {showNewPasswordState &&
                                            <>
                                                <div className="loginpSec position-relative">
                                                    <label htmlFor="txtPassword" className="form-label lbl">New Password<span className='required'>*</span></label>
                                                    <input
                                                        id="txtNewPassword"
                                                        placeholder="New Password"
                                                        ref={ref => (inputrefs.current['txtNewPassword'] = ref)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                if (showNewPasswordState) {
                                                                    inputrefs.current['txtConfirmPassword'].focus()
                                                                }
                                                                else {
                                                                    inputrefs.current['txtValidate'].focus()
                                                                }

                                                            };
                                                        }}
                                                        maxLength="15"
                                                        type={showPassword.newPassword ? 'text' : 'password'}
                                                        className="form-control txtField pass"
                                                        autoComplete="off"
                                                        value={loginData.newPassword}
                                                        onChange={(e) => handleChangeLogin(e, 'newPassword')}

                                                    />
                                                    <span style={{ position: "absolute", right: "10px", top: "65%", transform: 'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('newPassword')}>
                                                        {!showPassword.newPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                                    </span>
                                                </div>

                                                <div className="loginpSec position-relative">
                                                    <label htmlFor="txtPassword" className="form-label lbl">Confirm Password<span className='required'>*</span></label>
                                                    <input
                                                        id="txtConfirmPassword"
                                                        placeholder="Confirm Password"
                                                        ref={ref => (inputrefs.current['txtConfirmPassword'] = ref)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                inputrefs.current['btnVerify'].focus()
                                                            };
                                                        }}
                                                        maxLength="15"
                                                        type={showPassword.confirmPassword ? 'text' : 'password'}
                                                        className="form-control txtField pass"
                                                        autoComplete="off"
                                                        value={loginData.confirmPassword}
                                                        onChange={(e) => handleChangeLogin(e, 'confirmPassword')}
                                                    />
                                                    <span style={{ position: "absolute", right: "10px", top: "65%", transform: 'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('confirmPassword')}>
                                                        {!showPassword.confirmPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                                    </span>
                                                </div>
                                            </>
                                        }
                                        <div className="rmbr-me">
                                            <Link to='/' className="orSec"><u>Back To Login</u></Link>
                                        </div>
                                        {showNewPasswordState ? (
                                            <button
                                                type="button"
                                                ref={ref => (inputrefs.current['btnSub'] = ref)}
                                                id="btnLogin"
                                                className="pageBtn otpBtn btn-login"
                                                onClick={HandleSubmit}
                                            >
                                                Reset Password
                                            </button>
                                        ) : (null)}
                                    </div>
                                </div>
                                {isLoading && (<BlurLoader />)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default DealerForgotPassword;